import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface OnlineOnlyInterface {
    /**
     * Get data from endpoint and return promise
     */
    get<T>(query: string): Observable<T[] | T>;

    /**
     * Post json payload to endpoint and return promise
     *
     * @param  {string} query
     * @param  {Record<string, unknown>} payload payload that can be stringified
     * @returns {Promise} Promise
     */
    post<T>(query: string, payload: Record<string, unknown>): Observable<T[] | T>;

    /**
     * Send put request to backend
     */
    put(query: string, payload: Record<string, unknown>): Observable<undefined>;
}

export interface ResponseWithResults<T> {
    results: T[];
}

export interface OdataResponse<T> {
    d: ResponseWithResults<T> | T;
}

// Interface is based on the accepted options object for the angular http client request method
// extracted from node_modules/@angular/common/http/http.d.ts

export interface HttpOptions {
    body?: unknown;
    headers?:
        | HttpHeaders
        | {
              [header: string]: string | string[];
          };
    params?:
        | HttpParams
        | {
              [param: string]: string | string[];
          };
    observe?: 'body' | 'events' | 'response';
    reportProgress?: boolean;
    responseType?: 'arraybuffer';
    withCredentials?: boolean;
}

export function isResponseWithResults<T>(data: ResponseWithResults<T> | T): data is ResponseWithResults<T> {
    return !!(<ResponseWithResults<T>>data).results;
}
